import { useQuery } from '@tanstack/vue-query'
import { computed, type MaybeRefOrGetter, toValue } from 'vue'
import { apiRequest } from '@/libs/api/api'
import type { ListRecommendedActionsResponse } from '@/tokens/RecommendedActionCard/types'
import type { EntityMeResponse } from './types'

/**
 *
 * @param entityId - Reactive ref/computed or static string for entity ID
 */
export function useWhoAmI(entityId: MaybeRefOrGetter<string | undefined>) {
  const query = useQuery<EntityMeResponse, Error>({
    queryKey: computed(() => ['entities', 'me', toValue(entityId)]),
    queryFn: fetchWhoAmI,
    enabled: computed(() => Boolean(toValue(entityId))),
    retry: false,
  })

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  }
}

/**
 *
 */
async function fetchWhoAmI(): Promise<EntityMeResponse> {
  return await apiRequest('GET', '/entities/me')
}

/**
 *
 * @param entityId - Reactive ref/computed or static string for entity ID
 */
export function useRecommendedActions(
  entityId: MaybeRefOrGetter<string | undefined>
) {
  const query = useQuery({
    queryKey: computed(() => [
      'patients',
      'recommended_actions',
      toValue(entityId),
    ]),
    queryFn: fetchRecommendedActions,
    enabled: computed(() => Boolean(toValue(entityId))),
  })

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  }
}

/**
 *
 */
async function fetchRecommendedActions(): Promise<ListRecommendedActionsResponse> {
  return await apiRequest('GET', '/patients/recommended_actions')
}
